<script setup>
import { ref, onUnmounted } from "vue";
import CrowdfundingLiveOrganism from "/src/components/organisms/CrowdfundingLiveOrganism.vue";
import { stripe } from "/src/stripe.js";
import { useRoute, useRouter } from "vue-router";
import db from "../main.js"; //追加
import {
  doc,
  setDoc,
  onSnapshot,
  query,
  collection,
  getDocs,
  orderBy,
  where,
  Timestamp,
  // start_at,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";

const props = defineProps({
  user: Object,
});
const router = useRouter();
const showmessage = ref([]);

const route = useRoute();
// クラウドファンディングの場合はcampaignIdからevent_idを取得
const event_id = ref(route.params.campaignId);
const isLoadingforcredit = ref(true);
//メッセージを開いた時刻
let siteOpenTime = new Date(); // JavaScriptのDateオブジェクト

// Timestampオブジェクトに変換
let openMessageTime = Timestamp.fromDate(siteOpenTime);

// クラウドファンディング用：Crowdfunding_automessagesコレクションからメッセージを読み込む
const q = query(
  collection(db, "Crowdfunding_automessages", event_id.value, "automessages"),
  orderBy("created_at", "asc"),
  where("created_at", ">=", openMessageTime) //where条件を追加
);

let isFirstSnapshot = true;
let unsubscribeMessages = null;

unsubscribeMessages = onSnapshot(
  q,
  (querySnapshot) => {
    // 初回接続時は既存のドキュメントをすべて追加
    if (isFirstSnapshot) {
      querySnapshot.docs.forEach((doc) => {
        const data = doc.data();
        // created_atがページを開いた時刻以降か確認
        if (data.created_at && data.created_at.toMillis) {
          const messageTime = data.created_at.toMillis();
          const openTime = openMessageTime.toMillis();
          if (messageTime >= openTime) {
            showmessage.value.push(data);
          }
        } else {
          // created_atがTimestampでない場合も追加（念のため）
          showmessage.value.push(data);
        }
      });
      isFirstSnapshot = false;
    }

    // リアルタイム更新を監視（新規追加のみ）
    querySnapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        const setmessage = change.doc.data();
        // 重複チェック（ドキュメントIDで確認）
        const exists = showmessage.value.some((msg) => {
          // ドキュメントIDで比較するため、一度取得したドキュメントIDを保持する必要がある
          // ここでは、created_atとuidの組み合わせで重複チェック
          if (msg.created_at && setmessage.created_at) {
            return (
              msg.created_at.toMillis?.() === setmessage.created_at.toMillis?.() &&
              msg.uid === setmessage.uid &&
              msg.message === setmessage.message
            );
          }
          return false;
        });
        if (!exists) {
          showmessage.value.push(setmessage);
        }
      }
    });
  },
  () => {
    // エラーハンドリング
  }
);

//videoのURL用及びお茶代
const videourl = ref(null);
const ochaPrice = ref(0);
// getvideurlはvendorDataに統合（同じドキュメントを監視しているため）

const addresses = ref([]);

async function getAddressData() {
  addresses.value = [];
  const querySnapshot = await getDocs(collection(db, "users", props.user.uid, "addresses"));
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    addresses.value.push(data);
  });
}
getAddressData();
//登録済みクレジットカード呼び出し
const cardsInfo = ref(null);
const defaultCard = ref(null);
async function getCreditCard() {
  isLoadingforcredit.value = true;
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  const myCallableFunction = httpsCallable(functions, "Common_cardslist");
  myCallableFunction({})
    .then((result) => {
      cardsInfo.value = result.data.cards;
      defaultCard.value = result.data.defaultCardId;

      isLoadingforcredit.value = false;
    })
    .catch(() => {
      // エラーハンドリング
    });
}

const errorfortreca = ref(null); // エラー情報を保持するためのref
//トレカ購入（クレジットカード）
const supercommentDone = ref(false);
const comfirmBuy = async (selectitem, choosebuycard, comments, paymentMethodId, trecaid) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  //refを消す
  //価格
  const choosebuycardNo = choosebuycard.value;
  const createPaymentIntent = httpsCallable(functions, "Goods_TrecaCreatePaymentIntent");

  try {
    const result = await createPaymentIntent({
      paymentMethodId: paymentMethodId.value,
      choosebuycard: choosebuycardNo,
    });
    const clientSecret = result.data.clientSecret; // 修正ポイント
    const paymentIntentId = result.data.paymentIntentId;
    // オーソリが成功

    //    ここで次のステップに進む

    try {
      // クライアントで3Dセキュア認証を実行
      const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId.value,
      });

      if (confirmError) {
        errorfortreca.value = confirmError;
        return;
      }

      if (paymentIntent.status !== "requires_capture") {
        error.value = "hapen error";
        errorfortreca.value = "hapen error"; // エラー情報をrefにセット
        // error.value = error.message;
        return;
      }
      const event_idNo = event_id.value;
      const selectitemNo = selectitem.value;
      const trecaidNo = trecaid.value;

      // サーバーでキャプチャ処理を実行とスーパーコメント情報送付
      const captureTrecaPayment = httpsCallable(functions, "Goods_TrecaCapturePayment");
      const result = await captureTrecaPayment({
        choosebuycard: choosebuycardNo,
        paymentIntentId: paymentIntentId,
        paymentMethodId: paymentMethodId.value,
        comments: comments.value,
        event_id: event_idNo,
        orderItems: selectitemNo,
        trecaid: trecaidNo,
      });

      if (result.data.status === "succeeded") {
        supercommentDone.value = true;
      } else {
        alert("支払いキャプチャーに失敗しました: " + result.data.status);
        errorfortreca.value = "hapen error"; // エラー情報をrefにセット
      }
    } catch (err) {
      errorfortreca.value = err.message; // エラー情報をrefにセット
    }
  } catch (err) {
    errorfortreca.value = err.message; // エラー情報をrefにセット
  }
};

//トレカ購入（キャリア決裁）
const comfirmBuyforcarrierpayment = (
  selectitem,
  choosebuycard,
  comments,
  chooseaddress,
  cardId,
  trecaid
) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  //refを消す

  const choosebuycardNo = choosebuycard.value;
  const commentsNo = comments.value;
  const chooseaddressNo = chooseaddress.value;
  const event_idNo = event_id.value;
  const selectitemNo = selectitem.value;
  const trecaidNo = trecaid.value;
  const myCallableFunction = httpsCallable(functions, "Goods_TrecaChargeforcarrierpayment");
  myCallableFunction({
    choosebuycard: choosebuycardNo,
    comments: commentsNo,
    chooseaddress: chooseaddressNo,
    event_id: event_idNo,
    orderItems: selectitemNo,
    trecaid: trecaidNo,
  })
    .then((result) => {
      window.location.href = decodeURIComponent(result.data.redirectUrl);
    })
    .catch((error) => {
      error.value = error.message;
    });
};

// クラファンではカートアイテムの書き込みは不要（リターン選択で価格が確定するため）
// eslint-disable-next-line no-unused-vars
const chooseGoods = async () => {
  // クラファンでは使用しない（後方互換性のため関数は残す）
};

//トレカの種類を書き込み
const chooseTreca = async () => {
  if (props.user) {
    //カートへ書き込み
    await setDoc(
      doc(db, "users", props.user.uid, "Goods_supercommentcartitems", "supercommentcartitems"),
      {
        event_id: event_id.value,
        vendorname_ja: vendorname_ja.value,
      },
      {
        merge: false,
      }
    );
  }
};

const error = ref(null); // エラー情報を保持するためのref
//商品のグッズガチャ購入(クレジットカード)selectnumber, choosebuycard, chooseaddress, paymentMethodId
const orderId = ref();
const comfirmGoods = async (selectnumber, choosebuycard, chooseaddress, paymentMethodId) => {
  const functions = getFunctions();
  const createPaymentIntent = httpsCallable(functions, "Goods_CreatePaymentIntent");

  try {
    const result = await createPaymentIntent({
      paymentMethodId,
    });
    const clientSecret = result.data.clientSecret; // 修正ポイント
    const paymentIntentId = result.data.paymentIntentId;
    // オーソリが成功

    //    ここで次のステップに進む

    try {
      // クライアントで3Dセキュア認証を実行
      const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethodId,
        setup_future_usage: "on_session", // サービス内でユーザーが即時購入する場合
      });

      if (confirmError) {
        error.value = confirmError;
        return;
      }

      if (paymentIntent.status !== "requires_capture") {
        error.value = "hapen error";
        // error.value = error.message;
        return;
      }

      //refを消す
      const selectnumberNo = selectnumber.value;
      const choosebuycardNo = choosebuycard.value;
      const chooseaddressNo = chooseaddress.value;
      const event_idNo = event_id.value;
      //配信中の購入かどうか
      const buyfromlive = true;

      // サーバーでキャプチャ処理を実行と同時にガチャ情報送付
      const capturePayment = httpsCallable(functions, "Goods_CapturePayment");
      const result = await capturePayment({
        selectnumber: selectnumberNo,
        choosebuycard: choosebuycardNo,
        chooseaddress: chooseaddressNo,
        event_id: event_idNo,
        paymentIntentId: paymentIntentId,
        shippingFee: shippingFee.value,
        buyfromlive: buyfromlive,
        paymentMethodId: paymentMethodId,
      });

      if (result.data.status === "succeeded") {
        orderId.value = result.data.stripeOrderId;
        getCreditCard();
      } else {
        alert("支払いキャプチャーに失敗しました: " + result.data.status);
        error.value = "hapen error";
      }
    } catch (err) {
      error.value = err.message;
    }
  } catch (err) {
    error.value = err.message;
  }
};

//paidyでの商品購入（キャプチャー）
const comfirmGoodsforpaidy = (selectnumber, chooseaddress, paidyPaymentId) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  // refを消す
  const selectnumberNo = selectnumber.value;
  const chooseaddressNo = chooseaddress.value;
  const event_idNo = event_id.value;

  const buyfromlive = true;

  // Paidy決済用のCallable Functionを呼び出し
  const myCallableFunction = httpsCallable(functions, "Goods_PaidyCharge");

  myCallableFunction({
    selectnumber: selectnumberNo,
    chooseaddress: chooseaddressNo,
    event_id: event_idNo,
    shippingFee: shippingFee.value,
    buyfromlive: buyfromlive,
    paidyPaymentId: paidyPaymentId, // すでに取得済みのPaidy Payment IDを渡す
  })
    .then(() => {
      // 処理結果として、orderIdを取得
      orderId.value = paidyPaymentId;
    })
    .catch((err) => {
      error.value = err; // エラー情報をrefにセット
    });
};

// クラウドファンディング用：支援結果を保持
const crowdfundingSupportResult = ref(null);

// クラウドファンディング用：支援確定処理（イベントハンドラー）
const handleCrowdfundingSupport = async (supportData) => {
  const result = await comfirmCrowdfundingSupportInternal(supportData);
  // 結果を子コンポーネントに通知
  crowdfundingSupportResult.value = result;
  return result;
};

// クラウドファンディング用：支援確定処理（内部処理）
const comfirmCrowdfundingSupportInternal = async (supportData) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";

  try {
    if (supportData.paymentMethod === "creditcard") {
      // クレジットカード決済の場合
      // ステップ1: PaymentIntentを作成（オーソリ）
      const createPaymentIntent = httpsCallable(functions, "Crowdfunding_CreatePaymentIntent");

      const result = await createPaymentIntent({
        campaignId: supportData.campaignId,
        returnId: supportData.returnId,
        amount: supportData.amount,
        paymentMethodId: supportData.cardId,
        message: supportData.message,
      });

      const clientSecret = result.data.clientSecret;
      const paymentIntentId = result.data.paymentIntentId;

      // ステップ2: 3Dセキュア認証を実行
      const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: supportData.cardId,
        setup_future_usage: "on_session",
      });

      if (confirmError) {
        // エラーメッセージを日本語で表示
        let errorMessage = confirmError.message;
        if (confirmError.code === "card_expired" || errorMessage.includes("expired")) {
          errorMessage = "カードの期限が切れています。別のカードをお試しください。";
        } else if (confirmError.code === "card_declined") {
          errorMessage = "カードが拒否されました。別のカードをお試しください。";
        } else if (confirmError.code === "insufficient_funds") {
          errorMessage = "カードの残高が不足しています。別のカードをお試しください。";
        } else if (confirmError.code === "incorrect_cvc") {
          errorMessage = "セキュリティコードが正しくありません。";
        } else if (confirmError.code === "incorrect_number") {
          errorMessage = "カード番号が正しくありません。";
        } else if (!errorMessage) {
          // エラーメッセージが空の場合はデフォルトメッセージを使用
          errorMessage = "決済処理に失敗しました。別のカードをお試しください。";
        }
        // 既に日本語のメッセージが含まれている場合はそのまま使用（何もしない）
        error.value = errorMessage;
        return { success: false, error: errorMessage };
      }

      if (paymentIntent.status !== "requires_capture") {
        error.value = "決済処理に失敗しました";
        return { success: false, error: "決済処理に失敗しました" };
      }

      // ステップ3: キャプチャ処理を実行
      const capturePayment = httpsCallable(functions, "Crowdfunding_CapturePayment");
      const captureResult = await capturePayment({
        campaignId: supportData.campaignId,
        returnId: supportData.returnId,
        amount: supportData.amount,
        paymentIntentId: paymentIntentId,
        message: supportData.message,
        shippingAddress: supportData.shippingAddress,
      });

      if (captureResult.data.status === "succeeded") {
        orderId.value = captureResult.data.stripeOrderId || captureResult.data.orderId;
        await getCreditCard();
        // 成功を子コンポーネントに通知
        return { success: true };
      } else {
        const errorMsg = "支払いキャプチャーに失敗しました: " + captureResult.data.status;
        alert(errorMsg);
        error.value = "決済の確定に失敗しました";
        return { success: false, error: "決済の確定に失敗しました" };
      }
    } else if (supportData.paymentMethod === "paidy") {
      // Paidy決済の場合（BuyGoodscf.vue内でPaidy Checkoutが実行され、Payment IDが取得済み）
      const capturePaidy = httpsCallable(functions, "Crowdfunding_PaidyCharge");
      const result = await capturePaidy({
        campaignId: supportData.campaignId,
        returnId: supportData.returnId,
        amount: supportData.amount,
        paidyPaymentId: supportData.paidyPaymentId,
        message: supportData.message,
        shippingAddress: supportData.shippingAddress,
      });

      if (result.data.status === "succeeded" || result.data.text === "完了した") {
        orderId.value = supportData.paidyPaymentId;
        return { success: true };
      } else {
        error.value = "Paidy決済の確定に失敗しました";
        return { success: false, error: "Paidy決済の確定に失敗しました" };
      }
    }
  } catch (err) {
    error.value = err.message;
    return { success: false, error: err.message };
  }
};

//通常のコメントをデータベースへ書き込み
const commentinput = async (commenttext) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  //refを消す

  const campaignId = event_id.value;
  const normalmessageNo = commenttext.value;
  const myCallableFunction = httpsCallable(functions, "Crowdfunding_putnormalcomment");
  myCallableFunction({
    normalmessage: normalmessageNo,
    campaignId: campaignId,
  })
    .then(() => {
      // 処理完了
    })
    .catch(() => {
      // エラーハンドリング
    });
};

// ランキングデータはクラファンでは不要のため削除

//vtuberのグッズの商品データを取得
const goodsData = ref([]);
const getProductsData = async () => {
  const querySnapshot = await getDocs(collection(db, "Goods_products", event_id.value, "products"));
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    goodsData.value.push(data);
  });
};

getProductsData();

const sendaddress = async (postcode, address1, address2, name, phoneno) => {
  //refを消す
  const postcodeno = postcode.value;
  const address1no = address1.value;
  const address2no = address2.value;
  const nameno = name.value;
  const phonenono = phoneno.value;
  const functions = getFunctions();
  functions.region = "asia-northeast1"; // これを追加
  const addMessage = httpsCallable(functions, "Goods_Addaddress");
  await addMessage({
    postcode: postcodeno,
    address1: address1no,
    address2: address2no,
    name: nameno,
    phoneno: phonenono,
  }).then(async () => {
    await getAddressData();
  });
};
//表示用の金額と送料
const shippingFee = ref();
const totallPrice = ref();
const sumPrice = ref();

const shippingfeeandorderprice = async () => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  const func = httpsCallable(functions, "Goods_calcOrderPrice_and_shippingFee");

  try {
    const res = await func({ name: "hoge" });
    shippingFee.value = res.data.price_fee.shippingFee;
    totallPrice.value = res.data.price_fee.productPrice + res.data.price_fee.shippingFee;

    // クラファンではカートアイテムの読み取りは不要（リターン選択で価格が確定するため）
    // 従来のガチャ用のカート読み取り処理は削除
  } catch {
    // エラーハンドリング
  }
};

//vendor情報取得（リアルタイム更新）
const vendorsData = ref();
const vendorname_ja = ref();
const currentAmount = ref(0);
const targetAmount = ref(0);
let unsubscribeVendorData = null;
const vendorData = () => {
  // 既存のリスナーがあればクリーンアップ
  if (unsubscribeVendorData) {
    unsubscribeVendorData();
    unsubscribeVendorData = null;
  }

  unsubscribeVendorData = onSnapshot(
    doc(db, "Crowdfunding_projects", event_id.value),
    (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();

        // MainVendorInfoで使用するために、eventtitleプロパティを追加
        vendorsData.value = {
          ...data,
          eventtitle: data.projectTitle || "", // eventtitleの代わりにprojectTitleを使用
        };
        vendorname_ja.value = data.vendor_ja || "";
        // リアルタイムでcurrentAmountとtargetAmountを更新
        currentAmount.value = data.currentAmount || 0;
        targetAmount.value = data.targetAmount || 0;

        // 動画URLもここで更新（getvideurlと統合）
        // 同じURLで更新しないようにチェック
        if (data.videouid) {
          const newVideoUrl =
            (process.env.VUE_APP_CLOUDFLARE_SUBDOMAIN || "") +
            data.videouid +
            "/manifest/video.m3u8?protocol=llhls";
          // URLが実際に変更された場合のみ更新
          if (videourl.value !== newVideoUrl) {
            videourl.value = newVideoUrl;
          }
        }
        // クラウドファンディングにはocha_priceがないため、0のまま
        ochaPrice.value = 0;

        // streamingflagもここで更新（同じドキュメントを監視しているため統合）
        streamingflag.value = data.nowstreaming || false;
        if (streamingflag.value === false) {
          router.push(`/crowdfunding/${event_id.value}`);
        }
      }
    },
    () => {
      // エラーハンドリング
    }
  );
};
vendorData();

//デフォルトアドレスとデフォルトpaymentmethodの判定
const defaultAddress = ref(false);
const defaultpaymentmethod = ref(null);
let unsubscribeDefaultAddress = null;
const getDefaultAddress = () => {
  // 既存のリスナーがあればクリーンアップ
  if (unsubscribeDefaultAddress) {
    unsubscribeDefaultAddress();
    unsubscribeDefaultAddress = null;
  }
  unsubscribeDefaultAddress = onSnapshot(
    doc(db, "users", props.user.uid, "sub_accounts", "sub_accounts"),
    (doc) => {
      defaultAddress.value = doc.data().default_address;
      defaultpaymentmethod.value = doc.data().default_paymentmethod;
    }
  );
};
getDefaultAddress();

//商品のグッズガチャ購入(キャリア決裁)
const comfirmGoodsforcarrierpayment = (selectnumber, choosebuycard, chooseaddress) => {
  const functions = getFunctions();
  functions.region = "asia-northeast1";
  //refを消す
  const selectnumberNo = selectnumber.value;
  // const choosebuycardNo = choosebuycard.value;
  const chooseaddressNo = chooseaddress.value;
  const event_idNo = event_id.value;
  // const cardIdNo = cardId.value;
  const myCallableFunction = httpsCallable(functions, "Goods_requestCarrierPaymentforProducts");
  myCallableFunction({
    selectnumber: selectnumberNo,
    chooseaddress: chooseaddressNo,
    event_id: event_idNo,
    shippingFee: shippingFee.value,
  })
    .then((result) => {
      window.location.href = decodeURIComponent(result.data.redirectUrl);
    })
    .catch(() => {
      // エラーハンドリング
    });
};
//キャリアペイメントのgoodsのダイアログを再び開いて後オーダーIDを追加
orderId.value = String(route.query.orderid || "");
const goods_dialogaftercarrier = ref(false);
const goods_dialogaftercarrierfortreca = ref(false);
if (orderId.value.startsWith("vl")) {
  goods_dialogaftercarrier.value = true;
} else if (orderId.value.startsWith("gt")) {
  goods_dialogaftercarrierfortreca.value = true;
}

//streaming中かどうかを判定する。streaming中でなければリダイレクト
const streamingflag = ref(true);
// streamingflagの監視はvendorDataに統合（同じドキュメントを監視しているため）
const changecupercommentDone = () => {
  supercommentDone.value = false;
};

// コンポーネントのアンマウント時にすべてのリスナーをクリーンアップ
onUnmounted(() => {
  if (unsubscribeMessages) {
    unsubscribeMessages();
  }
  if (unsubscribeVendorData) {
    unsubscribeVendorData();
  }
  if (unsubscribeDefaultAddress) {
    unsubscribeDefaultAddress();
  }
});
</script>
<template>
  <CrowdfundingLiveOrganism
    :showmessage="showmessage"
    :videourl="videourl"
    :addresses="addresses"
    :defaultAddress="defaultAddress"
    :defaultpaymentmethod="defaultpaymentmethod"
    :cardsInfo="cardsInfo"
    :goodsData="goodsData"
    :orderId="orderId"
    :error="error"
    :errorfortreca="errorfortreca"
    :supercommentDone="supercommentDone"
    :defaultCard="defaultCard"
    :isLoadingforcredit="isLoadingforcredit"
    :shippingFee="shippingFee"
    :totallPrice="totallPrice"
    :sumPrice="sumPrice"
    :vendorsData="vendorsData"
    :goods_dialogaftercarrier="goods_dialogaftercarrier"
    :goods_dialogaftercarrierfortreca="goods_dialogaftercarrierfortreca"
    :ochaPrice="ochaPrice"
    @shippingfeeandorderprice="shippingfeeandorderprice"
    @comfirmBuy="comfirmBuy"
    @comfirmBuyforcarrierpayment="comfirmBuyforcarrierpayment"
    @comfirmGoodsforcarrierpayment="comfirmGoodsforcarrierpayment"
    @chooseGoods="chooseGoods"
    @chooseTreca="chooseTreca"
    @comfirmGoods="comfirmGoods"
    @comfirmGoodsforpaidy="comfirmGoodsforpaidy"
    @sendaddress="sendaddress"
    @commentinput="commentinput"
    @getAddressData="getAddressData"
    @getCreditCard="getCreditCard"
    @changecupercommentDone="changecupercommentDone"
    :user="user"
    :vendorname_ja="vendorname_ja"
    :campaignId="event_id"
    :currentAmount="currentAmount"
    :targetAmount="targetAmount"
    :crowdfundingSupportResult="crowdfundingSupportResult"
    @comfirmCrowdfundingSupport="handleCrowdfundingSupport"
  />
</template>

<style scoped>
.reset {
  width: 500px;
  height: 3000px;
}
</style>
